import { cva } from 'class-variance-authority';
import styles from './FocusStyles.module.css';

export const focusStyleVariants = cva('', {
  variants: {
    focusStyle: {
      default: styles.defaultFocus,
      white: styles.whiteFocus,
    },
  },
  defaultVariants: {
    focusStyle: 'default',
  },
});
